import { IconWrapper } from '../runtime';
export default IconWrapper('split-cell', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M6.25 4.99976V3.24976C6.25 2.42133 5.57843 1.74976 4.75 1.74976L3.25 1.74976C2.42157 1.74976 1.75 2.42133 1.75 3.24976L1.75 12.7498C1.75 13.5782 2.42157 14.2498 3.25 14.2498H4.75C5.57843 14.2498 6.25 13.5782 6.25 12.7498V11.1248M9.75 4.99976V3.24976C9.75 2.42133 10.4216 1.74976 11.25 1.74976L12.75 1.74976C13.5784 1.74976 14.25 2.42133 14.25 3.24976V12.7498C14.25 13.5782 13.5784 14.2498 12.75 14.2498H11.25C10.4216 14.2498 9.75 13.5782 9.75 12.7498V11.1248",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  }), h("path", {
    "attrs": {
      "d": "M10 6.74976L11.5 7.99976L10 9.24976M6.25 6.74976L4.75 7.99976L6.25 9.24976",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});